import React from 'react';
import './App.css';
import AppRoutes from './router';
import moment from 'moment-timezone';

function App() {
  moment.tz.setDefault('Europe/Istanbul')
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
